import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";
const steps = {
	initialDialog: 1,
	dialogTwo: 2,
	dialogThree: 3,
	dialogFour: 4,
	dialogfive: 55,
	dialogsix: 66,
	instructions: 5,
	selectOption: 6,
	selecScreen2: 101,
	selecScreen3: 102,
	selecScreen4: 103,
	selecScreen5: 104,
	selecScreen6: 105,
	finishAct: 50,
	dialogsevenExtra: 81,
	dialogseven: 8,
	dialognine: 9,
	selectCategory: 7,
	game: 200,
	gameWon: 1000,
	gamefail: 2000,
	viewActivities: 20,
	viewActivities2: 30,
	panelInstruction1: 31,
	panelInstruction2: 32,
	panelInstruction3: 33,
};

const stepClickScreen = {
	1: steps.selecScreen2,
	2: steps.selecScreen3,
	3: steps.selecScreen4,
	4: steps.selecScreen5,
	5: steps.finishAct
}

export const SubtopicThreeActivityOne = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();

	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.initialDialog);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema3], 1);

	useEffect(() => {
		if (loaded) {
			console.log("subtema 3 Activity one");
			ObserverEmitter.emit(EVENTS.subtopicThree.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicThree.activityone.clickScreen.listerClickScreen, (listenClick) => {
		const findList = stepClickScreen[listenClick]
		if (!findList) {
			return
		}
		setUiToShow(findList)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicThree.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.initialDialog && (
				<>
					<HeaderRedPresentation name="Actividad 1: Planograma." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Bien, es momento de continuar y aprender sobre el Planograma. Este es un esquema para distribuir la mercancías en una góndola, aprendamos mas de el."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivities);
						}}
						percentage={"10%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Planogramas."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<HeaderRedPresentation name="Actividad 1: Planograma." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Un planograma es un esquema el cual nos ayuda a distribuir los productos de manera adecuada."}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a03)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogThree);
						}}
						percentage={"20%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<HeaderRedPresentation name="Actividad 1: Planograma." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"El planograma se lee de la siguiente manera: Columna Charola: de abajo hacia arriba. Ejemplo: si dice 2, debes contar dos espacios arriba."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a04)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogFour);
						}}
						percentage={"30%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<HeaderRedPresentation name="Actividad 1: Planograma." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Columna Ubicación: de izquierda a derecha. Ejemplo: si dice 3, debes contar tres espacios de izquierda a derecha."}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a05)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogfive);
						}}
						percentage={"40%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogfive && (
				<>
					<HeaderRedPresentation name="Actividad 1: Planograma." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Columna Frentes: indica el número de filas o frentes que deben colocarse. Ejemplo: si dice 2, debes frentear 2 del producto indicado."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a06)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogsix);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogsix && (
				<>
					<HeaderRedPresentation name="Actividad 1: Planograma." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Columna Inventario: indica la cantidad de producto que debe estar exhibida. Ejemplo: si dice 4, debe estar colocado 4 de ese producto en la góndola."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a07)
							setUiToShow(steps.instructions);
						}}
						percentage={"60%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.instructions && (
				<>
					<HeaderRedPresentation name="Actividad 1: Planograma." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Habiendo visto lo que es un planograma, es momento de distribuir la mercancía en una góndola."}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a08)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.moveMonitor);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.clickScreen.moveScreen, 1);
							setUiToShow(steps.selectOption);
						}}
						percentage={"60%"}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.selectOption && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"En el menú principal, deberás de seleccionar la opción “Planogramas”, en el encontrarás todas las categorías de la tienda."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a09)
							setUiToShow(steps.selecScreen2);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img2, 2);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.clickScreen.moveScreen, 2);
						}}
						percentage={"65%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.selecScreen2 && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Después, selecciona la opción “Ultima versión de todos los Planogramas”.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a10)
							setUiToShow(steps.selecScreen3);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img3, 2);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.clickScreen.moveScreen, 3);
						}}
						percentage={"70%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.selecScreen3 && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`En la computadora selecciona "Refrigerado".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a11)
							setUiToShow(steps.selecScreen4);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img4, 2);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.clickScreen.moveScreen, 4);
						}}
						percentage={"75%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.selecScreen4 && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Ahora seleccionamos la categoría que necesitamos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act1_a12)
							setUiToShow(steps.selecScreen5);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.img5, 2);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.clickScreen.moveScreen, 5);
						}}
						percentage={"80%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.selecScreen5 && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Se va a desplegar el planograma en digital, necesitas imprimirlo para visualizarlo.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.finishAct);
						}}
						percentage={"85%"}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.finishAct && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Nuestro planograma nos ayudará a tener el orden correcto dentro de nuestra tienda."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema1.activities.subtema3,
								})
							);
							navigator("/home1/tema1/subtema3/activityTwo");
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.viewMonitor.hidden);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.clickScreen.moveScreen);
						}}
					/>
				</>
			)}
		</>
	);
};
